// frontend/src/pages/PackagesPage.jsx
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Loader2, Zap, Eye, Phone } from 'lucide-react';
import { PageSEO } from '../components/SEO/PageSEO';
import config from '../config';
import api from '../services/api';

// ============================================================
// آیکون‌های پیام‌رسان‌ها
// ============================================================

// آیکون واتساپ
const WhatsAppIcon = ({ className = "w-4 h-4" }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
  </svg>
);

// آیکون تلگرام
const TelegramIcon = ({ className = "w-4 h-4" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" />
  </svg>
);

// آیکون سروش
const SoroushIcon = ({ className = "w-4 h-4" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />
    <path d="M12 6c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6z" />
  </svg>
);

// آیکون بله
const BaleIcon = ({ className = "w-4 h-4" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />
    <path d="M12 6c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6z" />
  </svg>
);

// آیکون ایتا
const EitaaIcon = ({ className = "w-4 h-4" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />
  </svg>
);

// آیکون روبیکا
const RubikaIcon = ({ className = "w-4 h-4" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />
  </svg>
);

// کامپوننت انتخاب آیکون بر اساس نوع پیام‌رسان
const MessengerIcon = ({ type, className }) => {
  switch (type) {
    case 'telegram':
      return <TelegramIcon className={className} />;
    case 'soroush':
      return <SoroushIcon className={className} />;
    case 'bale':
      return <BaleIcon className={className} />;
    case 'eitaa':
      return <EitaaIcon className={className} />;
    case 'rubika':
      return <RubikaIcon className={className} />;
    case 'whatsapp':
    default:
      return <WhatsAppIcon className={className} />;
  }
};

export const PackagesPage = () => {
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedPower, setSelectedPower] = useState('');
  const [siteSettings, setSiteSettings] = useState(null);

  // دریافت تنظیمات سایت
  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await api.get('/cms/settings/get_settings/');
        setSiteSettings(response.data);
      } catch (error) {
        console.error('Error fetching settings:', error);
      }
    };
    fetchSettings();
  }, []);

  useEffect(() => {
    fetchPackages();
  }, [selectedPower]);

  const fetchPackages = async () => {
    setLoading(true);
    try {
      let url = config.getApiUrl('/products/packages/');
      if (selectedPower) url += `?power=${selectedPower}`;

      const accessToken = localStorage.getItem('access_token');
      const response = await fetch(url, {
        headers: {
          'Authorization': `Bearer ${accessToken}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        setPackages(data.results || data || []);
      }
    } catch (error) {
      console.error('Error fetching packages:', error);
    } finally {
      setLoading(false);
    }
  };

  // ========== توابع تماس و پیام ==========
  const handlePriceOnCall = (pkg) => {
    const phoneNumber = pkg.contact_phone || siteSettings?.contact_phone || config.CONTACT_PHONE;
    window.location.href = `tel:${phoneNumber}`;
  };

  const handleMessenger = (pkg) => {
    const settings = siteSettings || {};
    const messengerType = settings.messenger_type || 'whatsapp';
    const phone = settings.messenger_phone || settings.contact_phone || config.CONTACT_WHATSAPP || '';
    const username = settings.messenger_username || '';
    const link = settings.messenger_link || '';

    let messengerLink = link;

    if (!messengerLink) {
      const cleanPhone = phone.replace(/^0/, '').replace(/[^0-9]/g, '');

      switch (messengerType) {
        case 'whatsapp':
          messengerLink = `https://wa.me/98${cleanPhone}`;
          break;
        case 'telegram':
          messengerLink = username ? `https://t.me/${username}` : `https://t.me/${cleanPhone}`;
          break;
        case 'soroush':
          messengerLink = `https://sapp.ir/${username || cleanPhone}`;
          break;
        case 'bale':
          messengerLink = `https://bale.ai/${username || cleanPhone}`;
          break;
        case 'eitaa':
          messengerLink = `https://eitaa.com/${username || cleanPhone}`;
          break;
        case 'rubika':
          messengerLink = `https://rubika.ir/${username || cleanPhone}`;
          break;
        default:
          messengerLink = `tel:${phone}`;
      }
    }

    if (messengerLink) {
      window.open(messengerLink, '_blank');
    }
  };

  // تنظیمات پیام‌رسان
  const settings = siteSettings || {};
  const messengerType = settings.messenger_type || 'whatsapp';
  const messengerNames = {
    'whatsapp': 'واتساپ',
    'telegram': 'تلگرام',
    'soroush': 'سروش',
    'bale': 'بله',
    'eitaa': 'ایتا',
    'rubika': 'روبیکا',
  };
  const messengerDisplayName = messengerNames[messengerType] || 'پیام';

  // تابع کمکی برای نمایش قیمت
  const renderPrice = (pkg) => {
    if (pkg.show_price_on_call) {
      return (
        <div className="flex flex-col">
          <span className="text-sm text-green-600 font-medium">تماس برای قیمت</span>
          <span className="text-xs text-gray-400">مشاوره رایگان</span>
        </div>
      );
    }

    const finalPrice = pkg.discount_price || pkg.total_price;
    const originalPrice = pkg.total_price;
    const hasDiscount = originalPrice && finalPrice && originalPrice > finalPrice;

    if (!finalPrice && !originalPrice) {
      return (
        <span className="text-sm text-gray-500">قیمت نامشخص</span>
      );
    }

    return (
      <div>
        {hasDiscount && (
          <span className="text-gray-400 line-through text-sm block">
            {Number(originalPrice).toLocaleString('fa-IR')} تومان
          </span>
        )}
        <span className="text-xl font-bold text-blue-600">
          {Number(finalPrice).toLocaleString('fa-IR')} تومان
        </span>
      </div>
    );
  };

  const powerOptions = [5, 6, 8, 10, 15, 20];

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="w-10 h-10 animate-spin text-blue-600" />
      </div>
    );
  }

  return (
    <>
      <PageSEO
        title="پکیج‌های خورشیدی | سان ایران"
        description="خرید پکیج‌های آماده نیروگاه خورشیدی شامل پنل، اینورتر و تجهیزات نصب با بهترین قیمت و ضمانت"
        keywords="پکیج خورشیدی, پکیج برق خورشیدی, نیروگاه خورشیدی, پکیج آماده خورشیدی"
        type="website"
      />

      <div className="min-h-screen bg-gray-50 py-8">
        <div className="container mx-auto px-4">
          <h1 className="text-3xl font-bold text-center mb-4">پکیج‌های آماده خورشیدی</h1>
          <p className="text-gray-600 text-center mb-8 max-w-2xl mx-auto">
            انتخاب هوشمندانه بر اساس نیاز مصرفی شما - همه تجهیزات مورد نیاز در یک پکیج
          </p>

          <div className="flex justify-center gap-3 mb-8 flex-wrap">
            <button
              onClick={() => setSelectedPower('')}
              className={`px-4 py-2 rounded-lg transition ${!selectedPower ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-700'}`}
            >
              همه
            </button>
            {powerOptions.map(power => (
              <button
                key={power}
                onClick={() => setSelectedPower(power)}
                className={`px-4 py-2 rounded-lg transition ${selectedPower == power ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-700'}`}
              >
                {power} کیلووات
              </button>
            ))}
          </div>

          {packages.length === 0 ? (
            <div className="text-center py-12">
              <Zap className="w-16 h-16 text-gray-300 mx-auto mb-4" />
              <p className="text-gray-500">هیچ پکیجی یافت نشد</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {packages.map((pkg) => {
                const isPriceOnCall = pkg.show_price_on_call || false;

                return (
                  <div key={pkg.id} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition flex flex-col">
                    {/* تصویر پکیج */}
                    <div className="relative h-40 bg-gradient-to-r from-blue-500 to-purple-600">
                      {/* برچسب توان */}
                      <div className="absolute top-2 right-2 bg-yellow-500 text-white px-2 py-1 rounded-full text-sm font-bold z-10">
                        {pkg.power_display || `${pkg.power_value || pkg.power_rating} کیلووات`}
                      </div>

                      {/* ✅ برچسب "تماس برای قیمت" - به صورت تگ ساده (نه دکمه) */}
                      {isPriceOnCall && (
                        <div className="absolute top-2 left-2 bg-green-500 text-white px-3 py-1 rounded-full text-xs font-bold z-10">
                          تماس برای قیمت
                        </div>
                      )}
                    </div>

                    {/* محتوای پکیج */}
                    <div className="p-5 flex flex-col flex-grow">
                      <h3 className="text-xl font-bold mb-2 line-clamp-2">{pkg.name}</h3>
                      <p className="text-gray-500 text-sm mb-4 line-clamp-2">
                        {pkg.short_description || pkg.description?.replace(/<[^>]*>/g, '').substring(0, 150) || 'توضیحاتی برای این پکیج...'}
                      </p>

                      {/* قیمت یا دکمه‌های تماس */}
                      <div className="mt-auto">
                        {isPriceOnCall ? (
                          <div className="space-y-3">
                            <Link
                              to={`/packages/${pkg.slug}`}
                              className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 rounded-lg text-center flex items-center justify-center gap-2 transition text-sm"
                            >
                              <Eye className="w-4 h-4" />
                              مشاهده پکیج
                            </Link>

                            <div className="grid grid-cols-2 gap-2">
                              <button
                                onClick={(e) => {
                                  e.preventDefault();
                                  handlePriceOnCall(pkg);
                                }}
                                className="bg-green-600 hover:bg-green-700 text-white py-2 rounded-lg flex items-center justify-center gap-2 transition text-sm"
                              >
                                <Phone className="w-4 h-4" />
                                تماس
                              </button>
                              <button
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleMessenger(pkg);
                                }}
                                className="bg-blue-600 hover:bg-blue-700 text-white py-2 rounded-lg flex items-center justify-center gap-2 transition text-sm"
                              >
                                <MessengerIcon type={messengerType} className="w-4 h-4" />
                                {messengerDisplayName}
                              </button>
                            </div>
                          </div>
                        ) : (
                          // ========== حالت عادی (با قیمت) ==========
                          <div className="space-y-3">
                            <div className="flex items-center justify-between">
                              <div>
                                {renderPrice(pkg)}
                              </div>
                              {pkg.discount_percent > 0 && (
                                <span className="bg-red-500 text-white px-2 py-1 rounded-full text-xs">
                                  {pkg.discount_percent}% تخفیف
                                </span>
                              )}
                            </div>
                            <Link
                              to={`/packages/${pkg.slug}`}
                              className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 rounded-lg text-center flex items-center justify-center gap-2 transition text-sm"
                            >
                              <Eye className="w-4 h-4" />
                              مشاهده پکیج
                            </Link>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </>
  );
};